<template>
  <v-container fluid grid-list-md text-xs-center style="min-height: 93.4vh">
    <v-layout row wrap>
      <v-toolbar scroll-target="#scrolling-home" style="z-index: 1" extended>
        <v-toolbar-title v-show="!$vuetify.breakpoint.xsOnly">
          {{ $t('appointments.appointments_title') }}
        </v-toolbar-title>
        <v-toolbar-title
          v-show="$vuetify.breakpoint.xsOnly"
          style="width: 100%"
        >
          <v-flex class="titleSearch">
            <v-text-field
              class="mt-3"
              flat
              :label="$t('generic.search')"
              prepend-inner-icon="search"
              solo-inverted
              clearable
              @click:append-outer="filterSearch"
              @click:clear="filterSearch"
              @keyup.enter="filterSearch"
              v-model="search"
            />
          </v-flex>
        </v-toolbar-title>
        <v-tooltip
          right
          v-if="userPermissions[possibleUserModulePermissions.ADD_VISITS]"
        >
          <v-btn
            color="gradiente"
            dark
            :small="$vuetify.breakpoint.xsOnly"
            absolute
            bottom
            left
            fab
            slot="activator"
            @click="createNewVisit"
          >
            <v-icon>add</v-icon>
          </v-btn>
          <span>Crear cita</span>
        </v-tooltip>
        <template v-slot:extension>
          <v-layout row wrap>
            <v-flex xs12 v-show="!$vuetify.breakpoint.xsOnly">
              <v-layout row wrap>
                <v-flex xs12 sm6 md4 lg2 offset-sm2 offset-lg1>
                  <v-menu
                    v-model="modalF"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        id="first"
                        :value="momentFormatFirst"
                        :label="$t('appointments.start_date')"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      header-color="primary"
                      color="secondary"
                      locale="es-419"
                      v-model="timeFirst"
                      scrollable
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 md4 lg2>
                  <v-menu
                    v-model="modalL"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="momentFormatLast"
                        id="last"
                        :label="$t('appointments.end_date')"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      header-color="primary"
                      color="secondary"
                      locale="es-419"
                      v-model="timeLast"
                      scrollable
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 md4 lg2>
                  <v-select
                    @input="filterCollaborator"
                    :items="collaborators"
                    v-model="filters.idCollaborator"
                    item-value="id"
                    :item-text="collaboratorName"
                    clearable
                    :label="$t('appointments.contributor')"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6 md4 lg1>
                  <v-select
                    @input="filterStatus"
                    :items="statusDate"
                    v-model="filters.statuses"
                    :item-text="text"
                    item-value="value"
                    clearable
                    :label="$t('appointments.status')"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6 md4 lg3 offset-lg1 class="titleSearch">
                  <v-text-field
                    flat
                    :label="$t('generic.search')"
                    append-outer-icon="search"
                    clearable
                    solo-inverted
                    hide-details
                    @click:append-outer="filterSearch(false)"
                    @click:clear="filterSearch(true)"
                    @keyup.enter="filterSearch(false)"
                    v-model="search"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </template>
      </v-toolbar>
      <v-container
        elevation-2
        fluid
        id="scrolling-activity"
        style="max-height: 75vh"
        class="table-full"
      >
        <v-layout row wrap>
          <v-flex xs12>
            <v-data-table
              :key="socket.key"
              :headers="headers"
              :rows-per-page-items="[25, 50, 100]"
              :total-items="total"
              :items="visits"
              :loading="working.wVisits"
              :pagination.sync="pagination"
              item-key="id"
              no-results-text="No se encontraron coincidencias"
              :no-data-text="
                userPermissions[possibleUserModulePermissions.WATCH_VISITS]
                  ? working.wVisits
                    ? 'Cargando'
                    : visits.length > 0
                    ? ''
                    : 'No hay citas'
                  : 'No tienes permiso de ver citas'
              "
            >
              <template v-slot:headers>
                <tr>
                  <th
                    class="text-xs-left"
                    style="width: 250px; max-width: 250px; min-width: 250px"
                  >
                    {{ $t('appointments.subject') }}
                    <!--Nombre de la cita-->
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 250px; max-width: 250px; min-width: 250px"
                  >
                    {{ $t('appointments.start_date_time') }}
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 250px; max-width: 250px; min-width: 250px"
                  >
                    {{ $t('appointments.end_date_time') }}
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 250px; max-width: 250px; min-width: 250px"
                  >
                    {{ $t('appointments.host') }}
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 100px; max-width: 100px; min-width: 100px"
                  >
                    {{ $t('appointments.guests') }}
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 100px; max-width: 100px; min-width: 100px"
                  >
                    {{ $t('appointments.status') }}
                  </th>
                  <th style="width: 400px; max-width: 400px; min-width: 400px">
                    &nbsp;
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <tr
                  :class="
                    props.item.isFromSocket === true
                      ? 'custom_fade_in_bg_color'
                      : ''
                  "
                >
                  <td
                    class="text-xs-left"
                    style="width: 250px; max-width: 250px; min-width: 250px"
                  >
                    {{
                      !isNull(props.item.hosts) && !isNull(props.item.reason)
                        ? resizeString(props.item.reason)
                        : resizeString(props.item.name)
                    }}
                  </td>
                  <td
                    class="text-xs-left"
                    style="width: 250px; max-width: 250px; min-width: 250px"
                  >
                    {{
                      props.item.visitType == 'RANGE'
                        ? props.item.startDate
                        : props.item.date | formatDate
                    }}
                  </td>
                  <td
                    class="text-xs-left"
                    style="width: 250px; max-width: 250px; min-width: 250px"
                  >
                    {{
                      props.item.visitType == 'RANGE'
                        ? formatEndDate(props.item.endDate, true)
                        : formatEndDate(props.item.date)
                    }}
                  </td>
                  <td
                    class="text-xs-left"
                    style="width: 250px; max-width: 250px; min-width: 250px"
                  >
                    {{
                      props.item.hosts !== null
                        ? `${props.item.hosts.map(
                            (e) => ` ${e.firstName} ${e.lastName}`
                          )}`
                        : `${props.item.customVisitHosts.map(
                            (e) => ` ${e.name}`
                          )}`
                    }}
                  </td>
                  <td
                    class="text-xs-left"
                    style="width: 100px; max-width: 100px; min-width: 100px"
                  >
                    {{ props.item.peopleCount }}
                  </td>
                  <td
                    class="text-xs-left"
                    style="width: 100px; max-width: 100px; min-width: 100px"
                  >
                    {{ formatStatusES(props.item.status) }}
                  </td>
                  <td
                    style="width: 400px; max-width: 400px; min-width: 400px"
                    class="text-xs-left"
                  >
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="viewVisit(props.item)"
                          icon
                          :title="props.item.name"
                          :disabled="
                            !userPermissions[
                              possibleUserModulePermissions.WATCH_VISITS
                            ]
                          "
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon>visibility</v-icon>
                        </v-btn>
                      </template>

                      <span>Ver detalle</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="editVisit(props.item)"
                          icon
                          :disabled="
                            !userPermissions[
                              possibleUserModulePermissions.UPDATE_VISITS
                            ] || props.item.hosts === null
                          "
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon>edit</v-icon>
                        </v-btn>
                      </template>

                      <span>{{ $t('appointments.edit') }}</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="notifyVisit(props.item)"
                          icon
                          :disabled="
                            !userPermissions[
                              possibleUserModulePermissions.UPDATE_VISITS
                            ] || !props.item.anyEmail
                          "
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon>send</v-icon>
                        </v-btn>
                      </template>

                      <span>{{ $t('appointments.send_invitations') }}</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="generateEtiqueta(props.item)"
                          icon
                          :disabled="
                            !userPermissions[
                              possibleUserModulePermissions.UPDATE_VISITS
                            ]
                          "
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon>print</v-icon>
                        </v-btn>
                      </template>

                      <span>Imprimir etiquetas</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="deleteVisit(props.item)"
                          icon
                          :disabled="
                            !userPermissions[
                              possibleUserModulePermissions.UPDATE_VISITS
                            ]
                          "
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </template>

                      <span>{{ $t('appointments.delete') }}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
              <!-- <template v-slot:pageText="props">
                {{ props.pageStart }} - {{ props.pageStop }} de
                {{ props.itemsLength }}
              </template> -->
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>

    <VisitCreateModal
      v-if="modals.createVisit"
      v-model="modals.createVisit"
      :collaborators="collaborators"
      :userPermissions="userPermissions"
      @created="onNewVisit"
      @onClosed="onCancel"
      @loading="onLoading"
    />

    <VisitEditModal
      v-model="modals.editVisit"
      :visit="visit"
      :collaborators="collaborators"
      @cancelled="onCancel"
      @created="onEditVisit"
      :key="componentKey"
    />

    <VisitSummaryModal
      v-model="modals.summary"
      :visit="visit"
      @onClosed="onCancel"
      @onUpdate="onUpdatedVisit"
    />
    <VisitPreviewTagModal
      v-model="modals.previewVisit"
      :visitPreview="visitPreview"
      :checkIdPreview="checkIdPreview"
      :visit="visitPerson"
      :visitPerson="visitPass"
      @cancelled="onCancel"
      @reset-check="resetCheckBox"
      :visitPass="visitPass"
    />

    <desition
      @desition="$event ? onDeleteVisit() : ''"
      v-model="modals.confirmDelete"
      :title="$t('appointments.delete_appointment_title')"
      :description="$t('appointments.delete_appointment_description')"
    />

    <desition
      @desition="$event ? onConfirmNotify() : ''"
      v-model="modals.notify"
      :title="$t('appointments.confirm_send_notifications')"
      :description="
        $t('appointments.send_notifications') +
        '<br />' +
        $t('appointments.send_notifications_confirm')
      "
    />

    <loading v-model="working.wLoading" text="Trabajando" />
    <success
      v-model="toast.success"
      :text="$t('generic.successful_operation')"
    />
    <error v-model="toast.failed" text="Ups ocurrió un error" />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import desition from '../../../Dialogs/Confirm.vue'
import error from '../../../Dialogs/Error'
import loading from '../../../Dialogs/Loading'
import success from '../../../Dialogs/Success'
import VisitCreateModal from '../../../Sections/Visits/VisitCreateModal.vue'
import VisitEditModal from '../../../Sections/Visits/VisitEditModal.vue'
import VisitPreviewTagModal from '../../../Sections/Visits/VisitPreviewTagModal.vue'
import VisitSummaryModal from '../../../Sections/Visits/VisitSummaryModal.vue'

import moment from 'moment'
import { _getUserPermissions } from '../../../../utils/genericUtils'
import {
  ItemCollaborator,
  ItemCollaboratorListParser,
  isNull,
} from './modelsAdapter'

export default {
  components: {
    loading,
    success,
    error,
    desition,
    VisitCreateModal,
    VisitSummaryModal,
    VisitEditModal,
    VisitPreviewTagModal,
  },
  data: () => ({
    componentKey: 0,
    checkIdPreview: [],
    checkedAll: [],
    userPermissions: {},
    possibleUserModulePermissions: {
      // VISITS
      ADD_VISITS: 'ADD_VISITS',
      WATCH_VISITS: 'WATCH_VISITS',
      UPDATE_VISITS: 'UPDATE_VISITS',
      // STUDENTS
      WATCH_STUDENTS: 'WATCH_STUDENTS',
      // PARENTS
      WATCH_PARENTS: 'WATCH_PARENTS',
      // LEVELS
      WATCH_LEVELS: 'WATCH_LEVELS',
      // SUBGROUPS
      WATCH_SUBGROUPS: 'WATCH_SUBGROUPS',
    },
    modalF: false,
    modalL: false,
    timeFirst: moment().format('YYYY-MM-DD'),
    timeLast: moment().format('YYYY-MM-DD'),
    user: {},
    pagination: {
      sortBy: 'name',
    },
    filters: {
      search: '',
    },
    statusDate: [
      { text: 'Finalizadas', value: 'FINALIZED' },
      { text: 'Activas', value: 'ACTIVE' },
      { text: 'Próximas', value: 'NEAR' },
    ],
    search: '',
    flags: {
      loading: false,
    },
    toast: {
      success: false,
      failed: false,
    },
    modals: {
      createVisit: false,
      confirmDelete: false,
      editVisit: false,
      summary: false,
      notify: false,
      previewVisit: false,
    },
    working: {
      wVisits: false,
      wLoading: false,
    },
    collaborators: [],
    total: 0,
    visits: [],
    visitPass: [],
    visitPerson: null,
    visit: null,
    visitPreview: null,
    isEdit: false,
    headers: [
      {
        text: 'Nombre',
        align: 'left',
        value: 'title',
        filterItems: [],
      },
      {
        text: 'Fecha',
        value: 'date',
        align: 'left',
        filterItems: [],
      },
      {
        text: 'Colaborador',
        value: 'collaborator',
        align: 'left',
        filterItems: [],
      },
      {
        text: 'Invitados',
        value: 'peopleCount',
        align: 'left',
        filterItems: [],
      },
      {
        text: '',
        value: 'id',
        filterItems: [],
        align: 'center',
      },
    ],
    socket: {
      isConnected: false,
      room: null,
      key: 0,
    },
  }),
  filters: {},
  sockets: {
    connect(evt) {
      console.log('Connected', evt)
    },
    disconnect(evt) {
      console.log('Disconnected', evt)
    },
    reconnect() {
      console.log('Reconnected')
      this._subscribeWs()
    },
    message(notification) {
      this._message(notification)
    },
  },
  methods: {
    isNull,
    _message(visit) {
      this.visits.forEach((e) => e._resetIsFromSocket())
      const newVisit = new ItemCollaborator({ ...visit, isFromSocket: true })
      this.visits.unshift(newVisit)
      // key force update the table
      this.socket.key = Math.random()
      this.total++
    },
    _setRoom(idBranch) {
      this.socket = {
        ...this.socket,
        room: `${idBranch}-visits`,
      }
    },
    _subscribeWs() {
      const room = this.socket.room
      if (!this.socket.isConnected && !isNull(room)) {
        console.log('Connecting & subscribing to ', room)
        this.$socket.connect()
        this.$socket.emit('subscribe', room)
        this.socket.isConnected = true
      } else {
        console.log('No branch yet')
        setTimeout(() => {
          if (this.socket.isConnected && !isNull(room)) {
            console.log('already connected')
            this.$socket.emit('subscribe', room)
            return
          }
        }, 1000)
      }
    },
    _unSubscribeWs() {
      console.log('unsubscribing from ', this.socket.room)
      this.$socket.emit('unsubscribe', this.socket.room)
    },
    formatEndDate(date = '', isRange = false) {
      if (isRange) {
        return moment(new Date(date)).format('DD/MM/YYYY HH:mm:ss')
      }

      let newDate = ''
      if (date) {
        newDate = `${moment(new Date(date)).format('DD/MM/YYYY')} 23:59`
      } else {
        newDate = '-'
      }
      return newDate
    },
    formatStatusES(status) {
      switch (status) {
        case 'ACTIVE':
          return 'Activos'
        case 'NEAR':
          return 'Próximos'
        case 'FINALIZED':
          return 'Finalizados'
      }
    },
    onUpdatedVisit(visit) {
      if (visit) {
        this.visits.forEach(function (vis) {
          if (vis.id === visit.id) {
            vis.peopleCount = visit.peopleCount
          }
        })
      }
    },
    editVisit(visit) {
      this.visit = visit
      this.isEdit = true
      this.modals.editVisit = true
    },
    viewVisit(visit) {
      this.visit = visit
      this.modals.summary = true
    },
    deleteVisit(visit) {
      this.visit = visit
      this.modals.confirmDelete = true
    },
    onDeleteVisit() {
      this.working.wLoading = true
      this.$store
        .dispatch('visits/deleteVisit', this.visit.id)
        .then(() => {
          this.working.wLoading = false
          this.toast.success = true
          this.getVisits(true)
        })
        .catch(() => {
          this.toast.failed = true
          this.working.wLoading = false
        })
    },
    onCancel() {
      this.modals.editVisit = false
      this.modals.createVisit = false
      this.modals.confirmDelete = false
      this.modals.summary = false
      this.modals.notify = false
      this.modals.previewVisit = false
      this.$forceUpdate()
      this.componentKey += 1
    },
    onLoading(show) {
      this.working.wLoading = show
    },
    onEditVisit(success, visitEdit) {
      this.modals.editVisit = false
      this.componentKey += 1

      if (success) {
        const tempVisitEdit = {
          ...visitEdit,
          anyEmail: visitEdit.hosts.some((e) => e.email !== undefined),
        }

        this.visits = this.visits.map((e) =>
          e.id === visitEdit.id ? tempVisitEdit : e
        )
        this.visit = null
        this.toast.success = true
        this.toast.failed = false
        this.$forceUpdate()
      } else {
        this.toast.failed = true
        this.toast.success = false
      }
    },
    onNewVisit(event) {
      this.working.wLoading = false
      if (event.success) {
        event.new = true

        this.modals.createVisit = false
        this.toast.success = true
        this.getVisits(true)
      } else {
        this.toast.failed = true
      }
    },
    mapPermits() {
      this.userPermissions = _getUserPermissions({
        getUser: this.getUser,
        possibleUserModulePermissions: this.possibleUserModulePermissions,
      })
    },
    // mapPermits() {
    //   var catalogs = (((this.getUser || {}).webRole || {}).catalogs || []).map(
    //     (el) => el.name
    //   )
    //   this.permits.add = catalogs.indexOf('ADD_VISITS') >= 0
    //   this.permits.watch = catalogs.indexOf('WATCH_VISITS') >= 0
    //   this.permits.update = catalogs.indexOf('UPDATE_VISITS') >= 0
    //   this.wVisits = this.permits.watch
    // },
    filterSearch(clean) {
      if (!clean) {
        this.filters.search = this.search ? this.search : ''
      } else {
        this.filters.search = ''
      }
      if (!this.working.wLoading) {
        this.getVisits(true)
      }
    },
    filterCollaborator() {
      if (!this.working.wLoading) {
        this.getVisits(true)
      }
    },
    filterStatus() {
      if (!this.working.wLoading) {
        this.getVisits(true)
      }
    },
    createNewVisit(type) {
      this.visit = null
      this.isEdit = false
      this.modals.createVisit = true
    },
    notifyVisit(visit) {
      this.visit = visit
      this.modals.notify = true
    },
    onConfirmNotify() {
      this.working.wLoading = true
      this.$store
        .dispatch('visits/notifyVisit', {
          id: this.visit.id,
        })
        .then(() => {
          this.toast.success = true
        })
        .catch(() => {
          this.toast.failed = true
        })
        .finally(() => {
          this.visit = null
          this.working.wLoading = false
        })
    },
    getVisits(forceUpdate) {
      var offset = (this.pagination.page - 1) * this.pagination.rowsPerPage
      this.working.wVisits = true
      var params = {
        search: this.filters.search,
        id_collaborator: this.filters.idCollaborator,
        statuses: this.filters.statuses,
        page_size: this.pagination.rowsPerPage,
        offset: offset,
      }

      if (this.timeFirst) {
        params.from = this.timeFirst
      }
      if (this.timeLast) {
        params.to = this.timeLast
      }

      this.$store
        .dispatch('visits/getVisits', params)
        .then((response) => {
          this.working.wVisits = false
          this.visits = new ItemCollaboratorListParser({
            data: response.data.items,
          })
          this.total = response.data.total
          this.collaborators = response.data.collaborators
          if (forceUpdate) {
            this.$forceUpdate()
          }
        })
        .catch(() => {
          this.working.wVisits = false
        })
    },
    collaboratorName(collaborator) {
      return collaborator.firstName + ' ' + collaborator.lastName
    },
    resizeString(str) {
      if (str === null || str === '' || str === undefined) return 'Sin asunto'
      else if (str.length > 60) str = str.substring(0, 50) + '...'
      return str
    },
    select_All() {
      let checkId = this.checkedAll.map((i) => i.id)
      this.checkIdPreview = checkId
    },
    resetCheckBox(empty) {
      this.checkIdPreview = empty
    },
    passOneVisit(visitPass) {
      this.visitPass = visitPass
    },
    generateEtiqueta(visitPerson) {
      this.visitPerson = visitPerson
      var offset = ''
      var pageSize = ''
      if (this.pagination.rowsPerPage !== undefined) {
        offset = (this.pagination.page - 1) * this.pagination.rowsPerPage
        pageSize = this.pagination.rowsPerPage
      } else {
        offset = 0
        pageSize = 10
      }
      this.working.wVisits = true
      var params = {
        search: this.filters.search,
        page_size: pageSize,
        offset: offset,
      }
      this.$store
        .dispatch('visits/getVisitsPeople', {
          id: this.visitPerson.id,
          params: params,
        })
        .then((response) => {
          this.working.wVisits = false
          this.visitPreview = response.data
          this.visitPass = response.data.items[0]
          this.checkedAll = response.data.items
          this.modals.previewVisit = true

          this.select_All()
        })
        .catch(() => {
          this.working.wVisits = false
        })
    },
  },
  mounted() {
    this._setRoom(this.getBranch.id)
    this._subscribeWs()
    if (this.getUser.id) this.mapPermits()
    if (
      this.userPermissions[this.possibleUserModulePermissions.WATCH_VISITS] &&
      !this.visits.length > 0
    ) {
      this.getVisits(true)
    }
    // setTimeout(() => {
    // 	this._message()
    // }, 3000);
  },
  beforeDestroy() {
    this._unSubscribeWs()
  },
  watch: {
    getUser() {
      if (this.getUser.id) this.mapPermits()
      if (
        this.userPermissions[this.possibleUserModulePermissions.WATCH_VISITS] &&
        !this.visits.length > 0
      ) {
        this.getVisits(true)
      }
    },
    timeFirst() {
      this.getVisits()
      this.modalF = false
    },
    timeLast() {
      this.getVisits()
      this.modalL = false
    },
    pagination: {
      handler() {
        this.filters.size = this.pagination.rowsPerPage
        this.filters.offset =
          (this.pagination.page - 1) * this.pagination.rowsPerPage
        this.getVisits()
      },
      deep: true,
    },
    getBranch() {
      this._setRoom(this.getBranch.id)
      this._subscribeWs()
    },
  },
  computed: {
    momentFormatFirst() {
      if (this.timeFirst != null) {
        return moment(this.timeFirst).format('DD/MM/YYYY')
      }
      return ''
    },
    momentFormatLast() {
      if (this.timeLast != null) {
        return moment(this.timeLast).format('DD/MM/YYYY')
      }
      return ''
    },
    ...mapGetters(['getUser', 'getBranch']),
  },
}
</script>

<style>
.titleSearch .v-input .v-input__slot {
  border-radius: 33px !important;
}

.v-text-field--box .v-input__slot,
.v-text-field--outline .v-input__slot {
  display: flex !important;
  align-items: center !important;
  min-height: auto !important;
}
@keyframes ws_new_entry_bg_color {
  from {
    background-color: #8fbc8f;
  }
  to {
    background-color: transparent;
  }
}

.custom_fade_in_bg_color {
  animation-name: ws_new_entry_bg_color;
  animation-duration: 3s;
  animation-fill-mode: forwards;
}
</style>
<style scoped>
::v-deep.table-full .v-datatable.v-table > tbody {
  max-height: calc(100vh - 426px);
  min-height: calc(100vh - 426px);
}
::v-deep tbody tr:hover:not(.v-datatable__expand-row) {
  background-color: #eee !important;
}
</style>
